import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { Divider, Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import StarIcon from "@mui/icons-material/StarBorder";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import FrequentlyAskedFreeByCode from "./FrequentlyAskedFreeByCode";
import Checkout from "./Checkout";
import { LoadingSvg } from "../../../utils/SvgIcons";
import {
  getFreePackageByFreeCodeApi,
  getSitePackagesListApi,
} from "../../../../../services/packagesApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import ForwardIcon from "@mui/icons-material/Forward";
import mainContext from "../../../../../context/mainContext";
import { checkfreecodeforuseApi } from "../../../../../services/InfluencerApi";
const unitPriceDisplayValue = {
  rial: "ریال",
  toman: "تومان",
  thousandRials: "هزار ریال",
  thousandTomans: "هزار تومان",
  millionRials: "میلیون ریال",
  millionTomans: "میلیون تومان",
};
export default function FreeByCode({ hadleSelectFree }) {
  const { handleUserType, userTypes } = React.useContext(mainContext);
  const [code, setCode] = useState("");
  const [codeToken, setCodeToken] = useState(false);

  const checkCodeIsValid = async () => {
    let toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      const data = { code };
      const response = await checkfreecodeforuseApi(data);
      const resData = checkResponseData(response);
      if (resData["success"] && resData["data"]) {
        setCodeToken(resData["data"]["data"][0]["codeToken"]);
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        setCodeToken(false);
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error(error);
    }
  };

  const getFreePackage = async () => {
    let toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      const response = await getFreePackageByFreeCodeApi({ codeToken });
      const resData = checkResponseData(response);
      if (resData["success"] && resData["data"]["token"]) {
        localStorage.setItem(
          "token",
          JSON.stringify(response["data"]["token"])
        );
        console.log(userTypes);
        let cp = ["userPremium", ...userTypes];
        handleUserType(cp);
        setCodeToken(false);
        setCode("");
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      console.error(error);
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Container
        disableGutters
        maxWidth="sm"
        component="main"
        sx={{ pt: 2, pb: 6 }}
      >
        <Button
          size="small"
          color="info"
          variant="contained"
          onClick={() => {
            hadleSelectFree(false);
          }}
          startIcon={<ForwardIcon />}
        >
          بازگشت
        </Button>
        <Paper
          sx={{
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            pb: 3,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextField
              onChange={(e) => {
                setCode(e.target.value);
              }}
              size="small"
              label="کد دریافت رایگان برنامه"
              variant="outlined"
            />
            <Button
              sx={{ margin: "10px" }}
              onClick={() => {
                checkCodeIsValid();
              }}
              variant="contained"
              color="warning"
            >
              بررسی کد
            </Button>
          </Box>
          <Button
            disabled={!codeToken}
            sx={{ margin: "10px" }}
            onClick={() => {
              getFreePackage(true);
            }}
            variant="contained"
          >
            ثبت نهایی
          </Button>
        </Paper>
        <FrequentlyAskedFreeByCode />
      </Container>
    </Grid>
  );
}
